module.exports = __webpack_public_path__ + "img/logo-blue.ac49c557.png";